module.exports = __webpack_public_path__ + "static/media/sc.a93cc38b.png";